import axios from "../axios/axios";
import { setAccountingTypes, setAccounting } from "../store/actions/accountingAction";
import { errorDispatcher, setSelectItemLabels } from "../helpers";
import { setTableData } from "store/actions/dataTableAction";
import { appSetLoading, appSetSendingRequest } from "store/actions/appAction";

export const apiGetAccountingTypes =
  (token, type = "all", callback, filterAccountType) =>
    (dispatch, getState) => {
      const token = getState().businessReducer.business.token
      dispatch(appSetSendingRequest(true));
      axios
        .get("accountTypes", {
          headers: { Authorization: `Bearer ${token}` },
          params: { ...(type !== "all" && { type }), ...(filterAccountType && { filterAccountType }) },
        })
        .then((response) => {
          let data = type === "all" ? response.data.accountTypes : response.data.accountTypes.childs[0];
          if (!filterAccountType) {
            dispatch(appSetSendingRequest(false));
            dispatch(setAccountingTypes(data, type));

          }
          if (callback) callback(data, type);
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };
export const apiGetAccountingSalaries = (pagination, token) => (dispatch, getState) => {
  let url = "/accountings/salaries";

  if (pagination) {
    url += `&limit=${pagination.limit}&page=${pagination.page}`;
  }

  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      let data = response.data.accountings;
      dispatch(setTableData(data, response.data.paginate));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetAccountingTypeDetails = (accountingTypeId, token, callback, currencyId) => (dispatch, getState) => {
  dispatch(appSetLoading(true));
  let url = `/accountTypes/${accountingTypeId}/details`
  url += `?CurrencyId=${currencyId ? currencyId : 1}`
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
      // data: { currencyId }
    })
    .then((response) => {
      let details = response.data.details;
      if (details && details.length) {
        details = setSelectItemLabels(
          details,
          "id",
          details[0].name ? "name" : details[0].title ? "title" : "nickName"
        );
      }
      setAccounting(details);
      callback(details);
    })
    .catch((error) => { }).finally(() => {
      dispatch(appSetLoading(false));

    })
};

export const apiAddAccountingType = (accountType, token, callback) => (dispatch, getState) => {
  axios
    .post("accountTypes", accountType, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, true);
    });
};

export const apiUpdateAccountingType = (accountType, token, callback) => (dispatch, getState) => {
  accountType.accountingCode = null;
  axios
    .put(`accountTypes/${accountType.id}`, accountType, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, true);
    });
};

export const apiDeleteAccountingType = (accountTypeId, token, callback) => (dispatch, getState) => {
  axios
    .delete(`accountTypes/${accountTypeId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch, true);
    });
};
